module.exports = __webpack_public_path__ + "img/6.f76407e7.png";